module.exports = __webpack_public_path__ + "static/media/29ADMSPC26.5af68cd7.jpg";